/*
  Add here your own custom javascript codes
*/

let featuredReviewPageScrollY = 0
let featuredReviewSwipeStartX = 0
let featuredReviewSwipeStartY = 0
let featuredReviewSwipeActive = false
let featuredReviewSwipeTarget = null

const lockFeaturedReviewPage = () => {
  if (document.body.classList.contains('featured-review-dialog-open')) return

  featuredReviewPageScrollY = window.scrollY || document.documentElement.scrollTop || 0
  document.body.style.position = 'fixed'
  document.body.style.top = `-${featuredReviewPageScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.width = '100%'
  document.body.classList.add('featured-review-dialog-open')
}

const restoreFeaturedReviewScrollPosition = () => {
  const root = document.documentElement
  const previousScrollBehavior = root.style.scrollBehavior

  root.style.scrollBehavior = 'auto'
  document.body.classList.remove('featured-review-dialog-open')
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.width = ''
  window.scrollTo({ top: featuredReviewPageScrollY, behavior: 'auto' })

  window.requestAnimationFrame(() => {
    root.style.scrollBehavior = previousScrollBehavior
  })
}

const unlockFeaturedReviewPage = () => {
  restoreFeaturedReviewScrollPosition()
}

const hasOpenFeaturedReviewsList = (section) => {
  return Boolean(section?.querySelector('[data-featured-reviews-list-dialog]:not([hidden])'))
}

const handleFeaturedReviewDetailBack = (dialog) => {
  if (!dialog) return

  const section = dialog.closest('[data-featured-reviews]')
  const hasListReturn = dialog.dataset.featuredReviewReturnTarget === 'list' && hasOpenFeaturedReviewsList(section)

  dialog.hidden = true
  const lightbox = dialog.querySelector('[data-featured-review-lightbox]')
  if (lightbox) {
    lightbox.hidden = true
  }

  if (hasListReturn) {
    const listDialog = section.querySelector('[data-featured-reviews-list-dialog]')
    listDialog?.querySelector('[data-featured-reviews-list-body]')?.focus?.()
    return
  }

  unlockFeaturedReviewPage()
}

const openFeaturedReviewsListDialog = (button) => {
  const section = button.closest('[data-featured-reviews]')
  const listDialog = section?.querySelector('[data-featured-reviews-list-dialog]')
  const listBody = listDialog?.querySelector('[data-featured-reviews-list-body]')

  if (!listDialog) return

  listDialog.hidden = false
  if (listBody) {
    listBody.scrollTop = 0
  }
  lockFeaturedReviewPage()
  listDialog.querySelector('[data-featured-reviews-list-close]')?.focus()
}

const closeFeaturedReviewsListDialog = (listDialog) => {
  if (!listDialog) return

  const section = listDialog.closest('[data-featured-reviews]')
  const detailDialog = section?.querySelector('[data-featured-review-dialog]')
  const lightbox = detailDialog?.querySelector('[data-featured-review-lightbox]')

  if (lightbox) {
    lightbox.hidden = true
  }
  if (detailDialog) {
    detailDialog.hidden = true
  }
  listDialog.hidden = true
  unlockFeaturedReviewPage()
}

const closeFeaturedReviewStack = (dialog) => {
  const section = dialog?.closest('[data-featured-reviews]')
  const listDialog = section?.querySelector('[data-featured-reviews-list-dialog]')
  const lightbox = dialog?.querySelector('[data-featured-review-lightbox]')

  if (lightbox) {
    lightbox.hidden = true
  }
  if (dialog) {
    dialog.hidden = true
  }
  if (listDialog) {
    listDialog.hidden = true
  }

  unlockFeaturedReviewPage()
}

const setFeaturedReviewLightboxImage = (lightbox, imageButton, index) => {
  const image = lightbox.querySelector('[data-featured-review-lightbox-image]')
  const thumbs = lightbox.querySelector('[data-featured-review-lightbox-thumbs]')

  if (!image || !imageButton) return

  image.src = imageButton.dataset.featuredReviewImageSrc || imageButton.querySelector('img')?.src || ''
  image.alt = imageButton.dataset.featuredReviewImageAlt || imageButton.querySelector('img')?.alt || ''
  lightbox.dataset.activeIndex = String(index)

  thumbs?.querySelectorAll('[data-featured-review-lightbox-thumb]').forEach((thumb) => {
    thumb.classList.toggle('is-active', thumb.dataset.featuredReviewLightboxThumb === String(index))
  })
}

const openFeaturedReviewLightbox = (imageButton) => {
  const dialog = imageButton.closest('[data-featured-review-dialog]')
  const lightbox = dialog?.querySelector('[data-featured-review-lightbox]')
  const thumbs = lightbox?.querySelector('[data-featured-review-lightbox-thumbs]')
  const imageButtons = Array.from(dialog?.querySelectorAll('[data-featured-review-image-open]') || [])
  const activeIndex = imageButtons.indexOf(imageButton)

  if (!dialog || !lightbox || !thumbs || activeIndex < 0) return

  thumbs.replaceChildren(...imageButtons.map((button, index) => {
    const src = button.dataset.featuredReviewImageSrc || button.querySelector('img')?.src || ''
    const alt = button.dataset.featuredReviewImageAlt || button.querySelector('img')?.alt || ''
    const thumb = document.createElement('button')
    const image = document.createElement('img')

    thumb.type = 'button'
    thumb.className = 'featured-review-lightbox-thumb'
    thumb.dataset.featuredReviewLightboxThumb = String(index)
    thumb.setAttribute('aria-label', `画像 ${index + 1}`)
    image.src = src
    image.alt = alt
    thumb.append(image)

    return thumb
  }))

  setFeaturedReviewLightboxImage(lightbox, imageButton, activeIndex)
  lightbox.hidden = false
  lightbox.querySelector('[data-featured-review-lightbox-close]')?.focus()
}

document.addEventListener('click', (event) => {
  const listOpen = event.target.closest('[data-featured-reviews-list-open]')
  if (listOpen) {
    openFeaturedReviewsListDialog(listOpen)
    return
  }

  const listClose = event.target.closest('[data-featured-reviews-list-close]')
  if (listClose) {
    closeFeaturedReviewsListDialog(listClose.closest('[data-featured-reviews-list-dialog]'))
    return
  }

  const lightboxClose = event.target.closest('[data-featured-review-lightbox-close]')
  if (lightboxClose) {
    const lightbox = lightboxClose.closest('[data-featured-review-lightbox]')
    if (lightbox) {
      lightbox.hidden = true
    }
    return
  }

  const lightboxThumb = event.target.closest('[data-featured-review-lightbox-thumb]')
  if (lightboxThumb) {
    const dialog = lightboxThumb.closest('[data-featured-review-dialog]')
    const lightbox = lightboxThumb.closest('[data-featured-review-lightbox]')
    const imageButtons = Array.from(dialog?.querySelectorAll('[data-featured-review-image-open]') || [])
    const index = Number(lightboxThumb.dataset.featuredReviewLightboxThumb)
    setFeaturedReviewLightboxImage(lightbox, imageButtons[index], index)
    return
  }

  const imageOpen = event.target.closest('[data-featured-review-image-open]')
  if (imageOpen) {
    event.preventDefault()
    openFeaturedReviewLightbox(imageOpen)
    return
  }

  const close = event.target.closest('[data-featured-review-dialog-close]')
  if (close) {
    const dialog = close.closest('[data-featured-review-dialog]')
    closeFeaturedReviewStack(dialog)
    return
  }

  const detailBack = event.target.closest('[data-featured-review-dialog-back]')
  if (detailBack) {
    handleFeaturedReviewDetailBack(detailBack.closest('[data-featured-review-dialog]'))
    return
  }

  const review = event.target.closest('[data-featured-review-detail]')
  if (!review) return

  const section = review.closest('[data-featured-reviews]')
  const dialog = section?.querySelector('[data-featured-review-dialog]')
  const body = dialog?.querySelector('[data-featured-review-dialog-body]')
  const template = review.querySelector('[data-featured-review-template]')
  const backButton = dialog?.querySelector('[data-featured-review-dialog-back]')
  const openedFromList = Boolean(review.closest('[data-featured-reviews-list-dialog]'))

  if (!dialog || !body || !template) return

  body.innerHTML = template.innerHTML
  body.scrollTop = 0
  dialog.dataset.featuredReviewReturnTarget = openedFromList ? 'list' : 'page'
  if (backButton) {
    backButton.hidden = !openedFromList
  }
  dialog.hidden = false
  lockFeaturedReviewPage()
  dialog.querySelector('[data-featured-review-dialog-close]')?.focus()
})

document.addEventListener('touchstart', (event) => {
  const dialog = event.target.closest?.('[data-featured-review-dialog]:not([hidden])')
  const listDialog = event.target.closest?.('[data-featured-reviews-list-dialog]:not([hidden])')
  const lightbox = event.target.closest?.('[data-featured-review-lightbox]:not([hidden])')

  if ((!dialog && !listDialog) || lightbox || event.touches.length !== 1) {
    featuredReviewSwipeActive = false
    featuredReviewSwipeTarget = null
    return
  }

  featuredReviewSwipeActive = true
  featuredReviewSwipeTarget = dialog || listDialog
  featuredReviewSwipeStartX = event.touches[0].clientX
  featuredReviewSwipeStartY = event.touches[0].clientY
}, { passive: true })

document.addEventListener('touchmove', (event) => {
  if (!featuredReviewSwipeActive || event.touches.length !== 1) return

  const deltaX = event.touches[0].clientX - featuredReviewSwipeStartX
  const deltaY = event.touches[0].clientY - featuredReviewSwipeStartY

  if (deltaX > 24 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35) {
    event.preventDefault()
  }
}, { passive: false })

document.addEventListener('touchend', (event) => {
  if (!featuredReviewSwipeActive) return

  const touch = event.changedTouches[0]
  const deltaX = touch.clientX - featuredReviewSwipeStartX
  const deltaY = touch.clientY - featuredReviewSwipeStartY
  const target = featuredReviewSwipeTarget
  featuredReviewSwipeActive = false
  featuredReviewSwipeTarget = null

  if (deltaX > 72 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35) {
    if (target?.matches?.('[data-featured-review-dialog]:not([hidden])')) {
      handleFeaturedReviewDetailBack(target)
      return
    }

    if (target?.matches?.('[data-featured-reviews-list-dialog]:not([hidden])')) {
      closeFeaturedReviewsListDialog(target)
    }
  }
}, { passive: true })

document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' || event.key === ' ') {
    const review = event.target.closest?.('[data-featured-review-detail]')
    if (review) {
      event.preventDefault()
      review.click()
    }
  }

  if (event.key === 'Escape') {
    const visibleLightbox = document.querySelector('[data-featured-review-lightbox]:not([hidden])')
    if (visibleLightbox) {
      visibleLightbox.hidden = true
      return
    }

    const visibleDetailDialog = document.querySelector('[data-featured-review-dialog]:not([hidden])')
    if (visibleDetailDialog) {
      closeFeaturedReviewStack(visibleDetailDialog)
      return
    }

    const visibleListDialog = document.querySelector('[data-featured-reviews-list-dialog]:not([hidden])')
    if (visibleListDialog) {
      closeFeaturedReviewsListDialog(visibleListDialog)
    }
  }
})
